import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Config
import { getRoute } from "../../config/routes";

// Components
import CaseMediaGallery from "../CaseMediaGallery/CaseMediaGallery";

const GalleryHandler = ({
  data: sourceData,
  defaultRoute,
  detailRoute,
  withFilter,
  onOutOfFilter,
  ...rest
}) => {
  const { itemId, caseId } = useParams();
  const history = useHistory();

  const data = withFilter ? sourceData.filter(withFilter) : sourceData;

  const getCurrentIndex = () =>
    data.findIndex(({ id }) => String(id) === String(itemId));

  const selectedData = data[getCurrentIndex()];

  useEffect(() => {
    if (!sourceData?.length) return;

    if (!selectedData) {
      if (onOutOfFilter) {
        const outOfFilterItem = sourceData.find(i => i.id === itemId);
        if (outOfFilterItem) {
          onOutOfFilter(outOfFilterItem);
          return;
        }
      }
      history.push(getRoute(defaultRoute, { caseId }));
    }
  }, [caseId, defaultRoute, history, selectedData]);

  if (!itemId || !selectedData) return null;

  const canNavigate = data.length > 1;

  const nextElement = () => {
    if (!canNavigate) return;

    const currentIndex = getCurrentIndex();
    if (currentIndex === -1) return;

    let nextIndex = currentIndex + 1;
    if (nextIndex >= data.length) nextIndex = 0;

    history.push(
      getRoute(detailRoute, {
        caseId,
        itemId: data[nextIndex].id
      })
    );
  };

  const prevElement = () => {
    if (!canNavigate) return;

    const currentIndex = getCurrentIndex();
    if (currentIndex === -1) return;

    let nextIndex = currentIndex - 1;
    if (nextIndex < 0) nextIndex = data.length - 1;

    history.push(
      getRoute(detailRoute, {
        caseId,
        itemId: data[nextIndex].id
      })
    );
  };

  const handleClose = () => history.push(getRoute(defaultRoute, { caseId }));

  return (
    <CaseMediaGallery
      caseId={caseId}
      data={selectedData}
      onClose={handleClose}
      onNext={nextElement}
      onPrev={prevElement}
      open={Boolean(itemId)}
      {...rest}
    />
  );
};

GalleryHandler.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ).isRequired,
  defaultRoute: PropTypes.string.isRequired,
  detailRoute: PropTypes.string.isRequired,
  withFilter: PropTypes.func,
  onOutOfFilter: PropTypes.func
};

GalleryHandler.defaultProps = {
  withFilter: null,
  onOutOfFilter: null
};

export default GalleryHandler;
